module.exports = " <nav class=menu> <ul class=\"nav nav-pills nav-stacked\"> <menu-item v-for=\"item of menu\" :item=item></menu-item> </ul> </nav> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/menu/LeftMenu.vue
// module id = 503
// module chunks = 1